import { useEffect, useState } from 'react'

export function useScript(src, options = {}) {
  const [status, setStatus] = useState(() => {
    if (!src) {
      return 'error'
    }

    return 'loading'
  })

  useEffect(() => {
    if (!src) {
      return
    }

    let script = document.querySelector(`script[src="${src}"]`)

    if (script) {
      setStatus(script.getAttribute('data-status') ?? cachedScriptStatus ?? 'loading')
    } else {
      script = document.createElement('script')
      script.src = src
      script.async = true
      script.setAttribute('data-status', 'loading')
      document.body.appendChild(script)

      /* istanbul ignore next */
      const setAttributeFromEvent = event => {
        const scriptStatus = event.type === 'load' ? 'ready' : 'error'

        if (script) {
          script.setAttribute('data-status', scriptStatus)
        }
      }

      script.addEventListener('load', setAttributeFromEvent)
      script.addEventListener('error', setAttributeFromEvent)
    }

    /* istanbul ignore next */
    const setStateFromEvent = event => {
      const newStatus = event.type === 'load' ? 'ready' : 'error'
      setStatus(newStatus)
    }

    script.addEventListener('load', setStateFromEvent)
    script.addEventListener('error', setStateFromEvent)

    return () => {
      if (script) {
        script.removeEventListener('load', setStateFromEvent)
        script.removeEventListener('error', setStateFromEvent)
      }

      if (script && options.removeOnUnmount) {
        script.remove()
      }
    }
  }, [src, options.removeOnUnmount])

  return status
}
